<template>
<div class="chapter">
<div class="inner_page">
<p class="title"><a id="page_3"><span class="litblue"><b>COMFORT KNITTING &amp; CROCHET</b></span></a></p><a id="page_3">
<p class="title1"><span class="blue">Babies &amp; Toddlers</span></p>
<p class="centert"><span class="ash">50 knit and crochet designs using<br/>Berroco’s Comfort and Vintage yarns</span></p>
<p class="centert1a"><span class="blue">Norah Gaughan and the Berroco Design Team</span></p>
<p class="center"><span class="blue">Photographs by Ericka McConnell<br/>Photostyling by Danielle Gold</span></p>
<p class="centert1s"><span class="ash">STC CRAFT | A MELANIE FALICK BOOK<br/>STEWART, TABORI &amp; CHANG<br/>NEW YORK</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Title.vue?4fe4666f